import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { TipoMediador } from '../../model/tipomediador';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-tipomediador',
  templateUrl: './tipomediador.component.html',
  styleUrls: ['./tipomediador.component.scss']
})
export class TipoMediadorComponent implements OnInit {

  movSub: Subscription;
  tipomediador: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.gettipomediadors();
  }

  async gettipomediadors(){

    this.tipomediador = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("tipomediador/list").subscribe(
        (result: any) =>{

          this.tipomediador =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novotipomediador(){
    this.modalService.modalDetalhesTipoMediador.emit(null);
  }

  editar(tipomediador: TipoMediador){
    this.modalService.modalDetalhesTipoMediador.emit(tipomediador);
  }

  excluir(tipomediador: TipoMediador){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("tipomediador/delete", tipomediador).subscribe(
            (result) =>{

              this.toastr.success('Tipo Mediador excluído com sucesso!', 'Sucesso!');
              this.gettipomediadors();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
